// extracted by mini-css-extract-plugin
export var fadeIn = "_2w-0";